export const parseToOpts = (arr = [], keyLabel = "", keyValue = keyLabel) => {
  return arr.map((n) => ({
    label: n[keyLabel] || "NOT FOUND",
    value: n[keyValue] || "",
  }));
};

export const getInitialEquityFromHistorical = (historical = []) => {
  const newHistorical = [...historical];
  const initialEquity = newHistorical
    .reverse()
    .find((h) => parseFloat(h.totalEquity) > 0);
  return initialEquity?.totalEquity ?? 0;
};
